import {SODeleteAssessmentSummary} from '../../core/assessment-summary/so-delete-assessment-summary';
import {DeleteEntityProtocol} from 'lionheartland';
import {BaseDelete} from 'lionheartland';


export class RADeleteAssessmentSummary extends BaseDelete implements DeleteEntityProtocol {
  deleteClass = SODeleteAssessmentSummary;
}